<nz-divider></nz-divider>
<form nz-form *ngIf="load" [nzLayout]="'vertical'" [formGroup]="ICSApprovalForm">
  <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }">
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="approvalStatus" nzRequired>Approval Status
          <span nz-tooltip nzTitle="Approval Status">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Approval Status is Required'">
          <nz-select required [nzPlaceHolder]="'Approval Status'" id="approvalStatus" formControlName="approvalStatus"
            (ngModelChange)="approvalStatusChange($event)" [nzShowSearch]="true">
            <nz-option *ngFor="let i of approvalStatusList" [nzLabel]="i.label" [nzValue]="i.label"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="actionReject">
      <nz-form-item>
        <nz-form-label nzFor="rejectionReason" nzRequired>Rejection Reason
          <span nz-tooltip nzTitle="Rejection Reason">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Rejection Reason is Required'">
          <nz-select required [nzPlaceHolder]="'Rejection Reason'" id="rejectionReason" formControlName="rejectionReason"
            (ngModelChange)="rejectionReasonChange($event)" [nzShowSearch]="true">
            <nz-option *ngFor="let i of rejectionReason" [nzLabel]="i.label" [nzValue]="i.label"></nz-option>
            <nz-option nzValue="Others" nzLabel="Others"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24" [nzOffset] ="12"  *ngIf="rejectionOther">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Other Value Required'">
          <input required nz-input  placeholder="Please Specify..." id="rejectionOtherVal" formControlName="rejectionOtherVal"/>
        </nz-form-control>
      </nz-form-item>
    </div>


    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24"  *ngIf="sBoxingDays">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="sandboxType">Sandboxing Type
          <span nz-tooltip nzTitle="Sandbox Type">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'SandBoxing Type is Required'">
          <nz-radio-group (ngModelChange)="sandBoxingTypeChange()"  formControlName="sandboxDateType" id="sandboxDateType">
            <label nz-radio nzValue="days">Sand Boxing Days</label>
            <label nz-radio nzValue="range">Sand Boxing Range</label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>


    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24" *ngIf="sBoxingDays && ICSApprovalForm.value.sandboxDateType === 'days'" >
      <nz-form-item>
        <nz-form-label nzRequired nzFor="sandBoxingDays">Sand Boxing Days
          <span nz-tooltip nzTitle="Sand Boxing Days">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>

        <nz-form-control [nzErrorTip]="'Sand Boxing Days is Required'">
          <nz-input-number class="w100" [nzMin]="0" (keypress)="numberOnly($event)" placeholder="Sand Boxing Days"
            id="sandBoxingDays" formControlName="sandBoxingDays" ></nz-input-number>

        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24"  *ngIf="sBoxingDays && ICSApprovalForm.value.sandboxDateType === 'range'" >
      <nz-form-item>
        <nz-form-label nzRequired nzFor="startDate">Start Date
          <span nz-tooltip nzTitle="Start Date">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>

        <nz-form-control [nzErrorTip]="'Please select Start date'">
          <nz-date-picker (ngModelChange)="onStartDateChange($event)" [nzDisabledDate]="disabledStartDate"  id="startDate" formControlName="startDate" nzSize="default" 
          nzPlaceHolder="Start Date" [nzShowToday]="false" nzFormat="dd-MM-yyyy">
        </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24"  *ngIf="sBoxingDays && ICSApprovalForm.value.sandboxDateType === 'range'">
      <nz-form-item>
        <nz-form-label nzRequired nzFor="endDate">End Date
          <span nz-tooltip nzTitle="To Date">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>

        <nz-form-control [nzErrorTip]="'Please select End date'">
          <nz-date-picker [nzDisabledDate]="disabledEndDate"  id="endDate" formControlName="endDate" nzSize="default" 
          nzPlaceHolder="End Date" [nzShowToday]="false" nzFormat="dd-MM-yyyy">
        </nz-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24" *ngIf="appRemarks">
      <nz-form-item>
        <nz-form-label nzFor="approvalRemarks" nzRequired>Approval Remarks
          <span nz-tooltip nzTitle="Approval Remarks">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control [nzErrorTip]="'Approval Remarks is Required'">
          <textarea required rows="2" formControlName="approvalRemarks" nz-input id="approvalRemarks"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-label nzFor="internalRemarks">Internal Remarks
          <span nz-tooltip nzTitle="Internal Remarks">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control>
          <textarea rows="2" formControlName="internalRemarks" nz-input id="internalRemarks"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>


    <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" *ngIf="checkListData.length > 0">
    <nz-list [nzDataSource]="checkListData" nzBordered [nzHeader]="'Aeo CheckList'" [nzRenderItem]="item">
        <ng-template #item let-item>
          <nz-list-item [nzContent]="simpleLink">
            <ng-template #simpleLink>
              <label nz-checkbox [(ngModel)]="item.checked" id="updateSingleChecked" (ngModelChange)="updateSingleChecked(item)" [ngModelOptions]="{standalone: true}">{{item.label}}</label>
            </ng-template>
         </nz-list-item>
        </ng-template>
      </nz-list>
    </div>

  </div>
  <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }" *ngIf="addChargesView">
    <div nz-col [nzSpan]="12">
      <nz-form-item>
        <nz-form-label nzFor="addCharges" nzRequired>Add Charges
          <span nz-tooltip nzTitle="Add Charges">
            <i nz-icon class="icon-q" nzType="question-circle" nzTheme="outline"></i>
          </span>
        </nz-form-label>
        <nz-form-control>
          <nz-switch nzSize="small" [nzControl]="false" id="isAddCharges" (click)=isAddCharges($event)></nz-switch>

        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row [nzGutter]="{ xs: 8, sm: 8, md: 8, lg: 24, xl: 48, xxl: 48 }" *ngIf="AddCharges">
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-control>
          <nz-select [nzPlaceHolder]="'Charges'" id="addChargesChange" (ngModelChange)="addChargesChange($event)" 
            [nzShowSearch]="true">
            <nz-option nzValue="1" nzLabel="Charges1"></nz-option>
            <nz-option nzValue="2" nzLabel="Charges2"></nz-option>
            <nz-option nzValue="3" nzLabel="Charges3"></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzXl="12" nzLg="12"nzMd="24" nzSm="24" nzXs="24">
      <nz-form-item>
        <nz-form-control>
          <input nz-input placeholder="" />
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div nz-row>
    <div nz-col nzXl="24" nzLg="24" nzMd="24" nzSm="24" nzXs="24">
      <div class="float-right">
        <button nz-button [disabled]="canSubmit" id="onSubmit" (click)="onSubmit()">Submit</button>
      </div>
    </div>
  </div>

</form>
